import { HTMLAttributes } from 'react';
import clsx from 'clsx';

type CustomDividerProps = HTMLAttributes<HTMLDivElement>;

const CustomDivider = (props: CustomDividerProps) => {
  const { className } = props;
  return <div className={clsx('h-px w-full bg-black/10', className)}></div>;
};

export default CustomDivider;
